import { NUM_RESULTS_FOR_PAGE } from './constants'

export function getPaginationLink(index: number, startPage: number): number | null {
  return index % NUM_RESULTS_FOR_PAGE === 0 ? index / NUM_RESULTS_FOR_PAGE + startPage : null
}
